import $i18n from 'panda-i18n';
import React, { forwardRef, useCallback, useEffect, useState, } from 'react';
import classNames from 'classnames';
import { CnCard } from '@/components/cn-card';
import { CnIcon } from '@/components/cn-icon';
import { CnButton } from '@/components/cn-button';
import { CnModal } from '@/components/cn-modal';
import { mergeProps } from '@/utils/with-default-props';
import { CnDrawerFooter } from './footer';
const defaultProps = {
    placement: 'bottom',
    visible: false,
    titleAlign: 'left',
    closeMode: ['mask', 'close'],
};
const CnDrawerBase = (props, ref) => {
    const { className, placement, visible, titleAlign, height, closeMode, footer, width, title, okProps, onOk, cancelProps, onCancel, containerClassName, noCard, embeddable, onClose = () => { }, children, style = {}, ...others } = mergeProps(defaultProps, props);
    const prefix = 'cn-ui-m-';
    const drawerCls = classNames(`${prefix}drawer`, className, `${prefix}drawer--${placement}`);
    const [drawerVisible, setVisible] = useState(visible);
    const { children: okChildren = $i18n.get({
        id: 'Confirm',
        dm: '确认',
        ns: 'CnDrawer',
    }), visible: okVisible = true, ...restOkProps } = okProps || {};
    const { children: cancelChildren = $i18n.get({
        id: 'Cancel',
        dm: '取消',
        ns: 'CnDrawer',
    }), visible: cancelVisible = true, ...restCancelProps } = cancelProps || {};
    const showCloseIcon = Array.isArray(closeMode) && closeMode.indexOf('close') > -1;
    const hasCard = useCallback(() => {
        if (noCard) {
            return true;
        }
        if (embeddable) {
            return true;
        }
        let types = [];
        if (Array.isArray(children) && children.length > 0) {
            types = children.map((item) => item?.type?.displayName);
        }
        else {
            types = [children?.type?.displayName || ''];
        }
        return types.includes('CnCard');
    }, [children, noCard, embeddable]);
    // 临时解决 drawer 的微信小程序 光标覆盖问题
    useEffect(() => {
        if (visible) {
            setTimeout(() => {
                setVisible(true);
            }, 50);
        }
        else {
            setVisible(visible);
        }
    }, [visible]);
    return (React.createElement(CnModal, { ...others, ref: ref, maskClosable: closeMode.indexOf('mask') > -1, onClose: onClose, visible: drawerVisible, placement: placement, className: `${prefix}drawer-modal`, containerClassName: drawerCls, containerStyle: {
            width,
            height,
            ...style,
        } },
        React.createElement("div", { className: `${prefix}drawer-container` },
            title ? (React.createElement("span", { className: classNames(`${prefix}drawer-title`, {
                    [`${prefix}drawer-title--center`]: titleAlign === 'center',
                    // todo: 居中对齐有样式上的问题：
                    // 1. 如果文字超出，则文字会与  close icon 重叠
                    // 2. 如果设置多余的右边距，则居中对齐且文字较少时，文案不是绝对局中的
                    // 目前技术无法低成本做到判断文字超出与否，并特殊处理
                    [`${prefix}drawer-title--with-icon`]: titleAlign === 'left' && showCloseIcon,
                }) }, title)) : null,
            showCloseIcon ? (React.createElement("div", { className: `${prefix}drawer-close`, onClick: () => {
                    onClose('close');
                } },
                React.createElement(CnIcon, { className: `${prefix}drawer-close-icon`, type: "close" }))) : null,
            React.createElement("div", { className: classNames(`${prefix}drawer-body`, containerClassName) }, hasCard() ? children : React.createElement(CnCard, null, children)),
            footer && (React.createElement(CnDrawerFooter, null,
                footer,
                cancelVisible && (React.createElement(CnButton, { fullWidth: true, size: "large", onClick: onCancel, ...restCancelProps }, cancelChildren)),
                okVisible && (React.createElement(CnButton, { type: "primary", fullWidth: true, size: "large", onClick: onOk, ...restOkProps }, okChildren)))))));
};
const CnDrawer = forwardRef(CnDrawerBase);
CnDrawer.displayName = 'CnDrawer';
export { CnDrawer };
